import React from 'react'
import {get} from 'lodash'
import {UserContext} from '../../../context/User'
import './Calendar.scss'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'

const GetStarted = () => {
  const userContext = React.useContext(UserContext)
  const handleSubmit = () => {
    try {
      userContext
        .updateUserDetails({
          id: userContext.details.id,
          user: {
            reservation_tutorial: false,
          },
        })
        .then(() => {
          const calendarUrls = process.env.REACT_APP_RESERVATION_CALENDAR_WINDOW_URL.split(', ')
          calendarUrls.forEach(targetOrigin => {
            window.parent.postMessage(
              {key: 'CALENDAR', value: `${targetOrigin}?from_welcome`},
              targetOrigin
            )
          })
        })
    } catch (err) {
      console.log('err', err)
    }
  }

  return (
    <>
      <div className="header-text">
        Let's get started! <br></br>
      </div>
      <div className="content">Ready to give a calendar a spin?</div>
      <div className="content">Hit the "Get started" button to start creating a calendar view</div>
      {get(userContext, 'userDetail.isLoading') ? (
        <LoadingIndicator style={{width: '100%'}} />
      ) : (
        <div className="next-cta" onClick={() => handleSubmit()}>
          Get Started! &nbsp;&nbsp;<i className="fa fa-angle-right	"></i>
        </div>
      )}
    </>
  )
}

export default GetStarted
